import styled from "styled-components"

const AdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`

const ActuTaxo = styled.span`
  background-color: ${(props) => props.theme.d_color_gradients.d_dark};
`

const ActuTitle = styled.h1`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const ActualiteFooterContainer = styled.div`
  color: ${(props) => props.theme.d_color_gradients.d_dark};
`

export { AdditionalInfos, ActuTaxo, ActuTitle, ActualiteFooterContainer }
